import React from 'react';
//import loadingimage from './img/loading.gif'
import Loader from 'react-loader-spinner'
import './loading.scss';

function Loading() {
	return (
		<div className="loading">
			<Loader 
				type="RevolvingDot"
				color="#00BFFF"
				height="100"
				width="100"
			/>
		</div>
	)
}

export default Loading;